import styled from 'styled-components';
import { P, Gap, LinkButton, SvgIcon, List, theme, Toggle } from '@salecycle/ui-component-library';
import { parseExitIntentAreas } from '../../../utils';
import { ConfigurationOption } from '../../../components/ConfigurationOption';
import { ExitIntentAreas } from 'sections/onsite-campaigns/types';
import { InfoTooltip } from 'sections/onsite-campaigns/pages/CampaignEditor/components/InfoTooltip';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { ExitIntentAreaSelectorModal } from './ExitIntentSelelctorModal';

const maxExitIntents = Object.keys(ExitIntentAreas).length;

const SpecificEdges = styled.div`
  display: flex;
  flex-direction: row;
`;

export type ExitIntentConfigurationProps = {
  value: ExitIntentAreas[];
  onChange: (newValue: ExitIntentAreas[]) => void;
};

export function ExitIntentConfiguration({ value, onChange }: ExitIntentConfigurationProps) {
  const { t } = useTranslation('campaigns');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const allSelected = value.length === maxExitIntents;

  const toggleClicked = () => {
    onChange(allSelected ? [] : Object.values(ExitIntentAreas));
  };

  return (
    <>
      <ConfigurationOption>
        <P>
          Which areas of the browser should activate the exit intent event?{' '}
          <InfoTooltip
            displayInline
            title={t('onsite.campaignExitIntent.tooltipTitle')}
            content={t('onsite.campaignExitIntent.tooltipContent')}
          />
        </P>
        <Gap bottom={16} />
        <Toggle ariaLabel="All edges" label="All edges" onChange={toggleClicked} checked={allSelected} />
        {allSelected && <div style={{ margin: '-12px' }} />}
        {!allSelected && (
          <div style={{ marginTop: '-16px' }}>
            <SpecificEdges>
              <P>Specific edges</P>
              <Gap right={8} />
              <LinkButton onClick={() => setIsModalOpen(true)} underline>
                <SvgIcon id="pen" name="pen" color={theme.vars.newColor.blue2} />
                <Gap right={8} />
                {value.length === 0 ? 'Select ' : 'Edit selected '} edges
              </LinkButton>
            </SpecificEdges>
          </div>
        )}
        {!allSelected && value.length > 0 && value.length !== maxExitIntents && (
          <>
            <Gap bottom={8} />
            <List>
              {parseExitIntentAreas(value).map((area, index) => (
                <li key={index}>{area}</li>
              ))}
            </List>
          </>
        )}
      </ConfigurationOption>
      <ExitIntentAreaSelectorModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} value={value} onChange={onChange} />
    </>
  );
}
